import api from '@/services/api'

export default {
  login: ({ data }) => api.post('/auth/login', data),
  logout: () => api.get('/auth/logout'),
  refresh: ({ data }) => api.post('/auth/refresh-token', data),
  getUserData: () => api.get('/users/me')
}
